import { Component } from '@angular/core';

@Component({
  selector: 'app-terms-of-service-page',
  templateUrl: './terms-of-service-page.component.html',
  styleUrls: ['./terms-of-service-page.component.scss']
})
export class TermsOfServicePageComponent {

}
